import React from 'react';
import { Link } from 'gatsby';

import * as S from '../components/styles.css';

const Pagination = ({ numPages, currentPage, contextPage }) => {
  if (numPages <= 1) {
    return null;
  }

  return (
    <S.PaginationWrapper>
      <S.PaginationLabel>Sidor:</S.PaginationLabel>
      <S.Pagination>
        {Array.from({ length: numPages }).map((item, i) => {
          const index = i + 1;

          const baseLink = `/${contextPage ? `${contextPage}/` : ''}`;
          const link = index === 1 ? baseLink : `${baseLink}page/${index}`;

          return (
            <S.PaginationItem current={currentPage === index} key={link}>
              {currentPage === index ? <span>{index}</span> : <Link to={link}>{index}</Link>}
            </S.PaginationItem>
          );
        })}
      </S.Pagination>
    </S.PaginationWrapper>
  );
};

export default Pagination;
